module.exports = __webpack_public_path__ + "img/cta-section-image03.6258b6c8.png";